import type { PipelineFileCardModel } from "@/lib/pipelineBoard";

export interface PipelineBulkActionTargets {
  runDqIds: string[];
  confirmStructureIds: string[];
  retryIngestIds: string[];
  retryDqIds: string[];
  retryFailureIds: string[];
  runDqCount: number;
  confirmStructureCount: number;
  retryFailureCount: number;
}

/** Derive bulk-action eligible file sets from the pipeline board card model. */
export function getPipelineBulkActionTargets(
  cards: PipelineFileCardModel[]
): PipelineBulkActionTargets {
  const runDq = cards.filter((card) => card.canRunDataQuality);
  const confirmStructure = cards.filter(
    (card) =>
      card.canConfirmStructure && card.globalConfidence != null && card.requiresReview !== true
  );
  const retryIngest = cards.filter(
    (card) => card.extractionCategory === "failed" || card.extractionCategory === "cancelled"
  );
  const retryDq = cards.filter((card) => card.isMapped && card.dqxPhase === "failed");

  const retryFailureIdSet = new Set<string>();
  for (const card of retryIngest) retryFailureIdSet.add(card.fileId);
  for (const card of retryDq) retryFailureIdSet.add(card.fileId);

  return {
    runDqIds: runDq.map((card) => card.fileId),
    confirmStructureIds: confirmStructure.map((card) => card.fileId),
    retryIngestIds: retryIngest.map((card) => card.fileId),
    retryDqIds: retryDq.map((card) => card.fileId),
    retryFailureIds: [...retryFailureIdSet],
    runDqCount: runDq.length,
    confirmStructureCount: confirmStructure.length,
    retryFailureCount: retryFailureIdSet.size,
  };
}
